import { clsx } from 'clsx';
import type { ReactNode } from 'react';

type Variant = 'default' | 'elevated' | 'ghost';
type Padding = 'sm' | 'md' | 'lg';

export interface CardProps {
  variant?: Variant;
  padding?: Padding;
  hoverable?: boolean;
  header?: ReactNode;
  footer?: ReactNode;
  className?: string;
  children: ReactNode;
}

const VARIANT: Record<Variant, string> = {
  default: 'bg-bg-card border border-line',
  elevated: 'bg-bg-card border border-line shadow-[0_4px_12px_rgba(0,0,0,0.4)]',
  ghost: 'border border-line',
};

const PADDING: Record<Padding, string> = {
  sm: 'p-4',
  md: 'p-5',
  lg: 'p-6',
};

export function Card({
  variant = 'default',
  padding = 'md',
  hoverable,
  header,
  footer,
  className,
  children,
}: CardProps) {
  return (
    <div
      className={clsx(
        'rounded-xl',
        VARIANT[variant],
        hoverable && 'transition-colors duration-fast hover:border-line',
        className,
      )}
    >
      {header && <div className={clsx('border-b border-line', PADDING[padding])}>{header}</div>}
      <div className={PADDING[padding]}>{children}</div>
      {footer && <div className={clsx('border-t border-line', PADDING[padding])}>{footer}</div>}
    </div>
  );
}
